import { makeStyles } from '@mui/styles';
import Skeleton from '@mui/material/Skeleton';

const useStyles = makeStyles((theme) => ({
  '5xlarge': {
    width: theme.spacing(40),
    height: theme.spacing(40),
    fontSize: '15em',
    transform: 'inherit'
  },
  '4xlarge': {
    width: theme.spacing(35),
    height: theme.spacing(35),
    fontSize: '10em',
    transform: 'inherit'
  },
  xlarge: {
    width: theme.spacing(20),
    height: theme.spacing(20),
    fontSize: '8.5em',
    transform: 'inherit'
  },
  large: {
    width: theme.spacing(15),
    height: theme.spacing(15),
    fontSize: '7.5em',
    transform: 'inherit'
  },
  xmedium: {
    width: theme.spacing(10),
    height: theme.spacing(10),
    fontSize: '5em',
    transform: 'inherit'
  },
  medium: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    fontSize: '3.5em',
    transform: 'inherit'
  },
  dashboard: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    fontSize: '2.5em',
    transform: 'inherit'
  },
  chart: {
    width: theme.spacing(5.5),
    height: theme.spacing(5.5),
    fontSize: '2em',
    transform: 'inherit'
  },
  small: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    fontSize: '1.5em',
    transform: 'inherit'
  },
  xsmall: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    fontSize: '0.8em',
    transform: 'inherit'
  }
}))


/*  AvatarSkeleton
 *  @params src             string    source photo
 *  @params showButton      bool      show button upload
 */

const AvatarSkeleton = ({ variant, size = 'large' }) => {
  const classes = useStyles()
  
  return <Skeleton variant={variant} className={classes[size]} />
}

export default AvatarSkeleton
